"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ng2_sticky_directive_1 = require("./ng2-sticky.directive");
exports.Ng2StickyDirective = ng2_sticky_directive_1.Ng2StickyDirective;
var ng2_sticky_module_1 = require("./ng2-sticky.module");
exports.Ng2StickyModule = ng2_sticky_module_1.Ng2StickyModule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-sticky/dist/index.js
// module id = 79
// module chunks = 0